/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputFilePresign
 */
export interface InputFilePresign {
    /**
     * 
     * @type {string}
     * @memberof InputFilePresign
     */
    filename: string;
    /**
     * 
     * @type {number}
     * @memberof InputFilePresign
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof InputFilePresign
     */
    mime: string;
    /**
     * 
     * @type {number}
     * @memberof InputFilePresign
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InputFilePresign
     */
    width: number;
}

/**
 * Check if a given object implements the InputFilePresign interface.
 */
export function instanceOfInputFilePresign(value: object): boolean {
    if (!('filename' in value)) return false;
    if (!('height' in value)) return false;
    if (!('mime' in value)) return false;
    if (!('size' in value)) return false;
    if (!('width' in value)) return false;
    return true;
}

export function InputFilePresignFromJSON(json: any): InputFilePresign {
    return InputFilePresignFromJSONTyped(json, false);
}

export function InputFilePresignFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputFilePresign {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'height': json['height'],
        'mime': json['mime'],
        'size': json['size'],
        'width': json['width'],
    };
}

export function InputFilePresignToJSON(value?: InputFilePresign | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'filename': value['filename'],
        'height': value['height'],
        'mime': value['mime'],
        'size': value['size'],
        'width': value['width'],
    };
}

